module.exports = __webpack_public_path__ + "img/CellCycle-PRCA_10X_AIC.9b203dad.png";